import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})

export class TipService {
  private tip:number = 0;

setTip(tip:number){
  this.tip = tip;
}

getTip(){
  return this.tip;
}
}
